<script setup lang="ts">
  import { ref } from 'vue'
  import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    useDialogZIndex
  } from '@gat-ship/vue-components'
  import { useGlobalSearchContextMetadata } from '../composables/useGlobalSearchContextMetadata'

  const contextMetadata = useGlobalSearchContextMetadata()

  const shorthandContexts = Object.values(contextMetadata).filter(
    (metadata) => metadata !== contextMetadata.global
  )

  const isOpen = ref(false)
  // Floats above the search dialog (and its stack context) automatically —
  // see `useDialogZIndex`'s monotonic transient-overlay counter.
  const { zIndex } = useDialogZIndex(isOpen)
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogTrigger v-if="$slots.trigger" as-child>
      <slot name="trigger" />
    </DialogTrigger>
    <DialogContent :overlay-z-index="zIndex">
      <DialogHeader>
        <DialogTitle>Shorthands for context searches</DialogTitle>
        <DialogDescription>
          You can use shorthands to quickly switch between different contexts.
        </DialogDescription>
      </DialogHeader>
      <div class="text-muted-foreground text-sm">
        For example, to search for clients you can use the shorthand "{{
          contextMetadata.client.prefix
        }}:" by just typing it in the search bar.
      </div>
      <div
        class="text-muted-foreground grid grid-cols-[auto_auto_minmax(0,1fr)] text-sm"
      >
        <div class="text-foreground border-b px-4 py-2 text-xs font-medium">
          Shorthands
        </div>
        <div class="text-foreground border-b px-4 py-2 text-xs font-medium">
          Contexts
        </div>
        <div class="text-foreground border-b px-4 py-2 text-xs font-medium">
          Description
        </div>
        <template v-for="metadata in shorthandContexts" :key="metadata.prefix">
          <div class="border-b px-4 py-2">{{ metadata.prefix }}:</div>
          <div class="border-b px-4 py-2">{{ metadata.title }}</div>
          <div class="border-b px-4 py-2">{{ metadata.description }}</div>
        </template>
      </div>
    </DialogContent>
  </Dialog>
</template>
